<template slot-scope="scope">
  <!-- 充值弹窗 -->
  <div>
      <!-- 充值选择金额 -->
      <dialogModel
        title="充值"
        :visible="dialogVisible"
        @handleClose="handleClose"
        @handleOk="handleUnderstand"
        width="600px"
      >
        <div class="main-body">
            <label class="label-text">金额：</label>
            <div class="amount-Select">
              <span
                v-for="(item, index) in amountList"
                :key="index"
                :class="item.data == SelectAmount ? 'SelectAmount' : ''"
                @click="handelClickAmount(item)"
              >
                {{ item.data }}
              </span>
              <input
                type="text"
                v-model="input"
                inputmode="numeric"
                placeholder="请输入其他金额"
                @input="handleAmountInput"
                @blur="handelBlur"
                @focus="handelFocus"
              />
            </div>
            <label class="label-text">支付方式：</label>
            <div class="Payment-method">
              <div class="way" v-for="(item, index) in listArr" :key="index">
                <div
                  :class="Select == item.id ? 'Select' : 'notSelect'"
                  @click="handelClick(item)"
                ></div>
                <div class="icon"><img :src="item.imgUrl" alt="" /></div>
                <span>{{ item.name }}</span>
              </div>
            </div>
            <div class="Events">充值活动：1RMB=1侦迹币</div>
            <div class="agreement-text">付费即表示同意 <span style="color: #409eff ; cursor: pointer;" @click="handelAgreement">《侦迹云增值服务协议》</span></div>
          </div>
      </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :queryType="'info'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../ProxyService/Enterprise/Bookkeeping/components/IndexCom/VerificationPwd.vue";
import {
  queryCompanyPaySetting, //查询是否开通了支付密码
} from "../../../../../assets/api/Agency/Enterprise";
import {
  pay, //支付
} from "../../../../../assets/api/firm/firmActivity";
import { PAYMENT_OPTIONS_WITH_IMAGE, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";

export default {
  props: {
    dialogVisible: {}, // 开启/关闭 选择金额弹窗
  },
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      imgUrl: require("@/assets/imgs/erweima2.svg"), // 二维码

      amountList: [
        { data: "50", id: "1" },
        { data: "100", id: "2" },
        { data: "150", id: "3" },
        { data: "200", id: "4" },
        { data: "300", id: "5" },
        { data: "500", id: "6" },
        // { ipt: "1" },
      ], //金额选择
      SelectAmount: "50", // 选择充值金额
      input: "", // 手动输入充值金额
      Select: DEFAULT_PAYMENT_METHOD, // 选择支付方式
      listArr: PAYMENT_OPTIONS_WITH_IMAGE, // 支付方式选择数据
      VisiblePayment: false, //扫码支付弹窗
      VisiblePwd: false, //支付密码验证
      alipayForm: ``, //支付弹窗二维码
      totalAmount:'',
      businessType: "",
      payMethod: "",
      orderId: "",
      PaymentPassword: false, //账号是否开启支付密码  开启的话充值前需验证
    };
  },
  computed: {},
  created() {
    this.queryCompanyPaySetting();
  },
  methods: {
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
      // this.$router.push("/PaymentCompleted");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 支付密码确认成功提交
    handleUnderstandPwd(pwd) {
      // pwd支付密码
      console.log("提交");
      
      var data = {
        data: {
          businessType: "COMPANY_WALLET_TOP_UP",
          payMethod: this.Select,
          password: pwd,
          businessInfo: {
            amount: this.SelectAmount != "" ? this.SelectAmount : this.input,
          },
        },
      };
      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false;
          // this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage
          this.totalAmount = res.data.totalAmount
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;

          this.VisiblePayment = true;
        }else{
          this.VisiblePwd = false;
        }
      });
    },
    // 查询是否开通支付密码
    queryCompanyPaySetting() {
      queryCompanyPaySetting().then((res) => {
        if (res.code == 0) {
          this.PaymentPassword = res.data;
        }
      });
    },
    //input失去焦点
    handelBlur() {
      // 手动输入金额 完毕判断不能输入0/空
      if (this.input != "" && this.input > 0) {
      } else {
      }
    },
    //input获取焦点
    handelFocus() {
      // 手动输入充值金额时 选择的金额自动清空选中
      this.SelectAmount = "";
    },
    // 只允许输入数字 
    handleAmountInput(e) {
      let val = e.target.value || "";
      // 过滤非数字字符
      val = val.replace(/[^\d]/g, "");
      // 限制最大值为100000
      if (val && parseInt(val) > 100000) {
        val = "100000";
      }
      e.target.value = val;
      this.input = val;
    },
    // 选择充值金额
    handelClickAmount(item) {
      this.SelectAmount = item.data;
    },
    // 选择支付方式
    handelClick(item) {
      this.Select = item.id;
    },
    // 点击协议查看协议详情
    handelAgreement() {
      const route = this.$router.resolve({
        path: "/AboutUs/Express",
        query: { name: "侦迹云增值服务协议" },
      });
      window.open(route.href, '_blank');
    },

    // 关闭弹窗
    handleClose() {
      this.$emit("handleClose");
      //   this.dialogVisible = false;
    },

    // 确认选择金额完毕
    handleUnderstand() {
      // this.$emit("handleUnderstand", this.dialogDele);
      // 选择/输入金额没有问题打开扫码支付弹窗
      if (this.SelectAmount != "" || (this.input != "" && this.input > 0)) {
        if (this.PaymentPassword) {
          // 有支付密码 开启密码验证弹窗
          this.VisiblePwd = true;
        } else {
          // 没有支付密码 直接开启扫码充值弹窗
          this.handleUnderstandPwd();
        }
      } else {
        // 选择/输入金额有误提示
        this.$tool.PromptBox("warning", "请选择/输入充值金额");
      }
    },
  },
};
</script>

<style scoped lang="less">
input {
  outline: none;
  height: 23px;
  line-height: 23px;
  width: 155px;
  border-radius: 5px;
  border: 1px solid #409eff ;
  font-family: PingFangSC-Medium;
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  text-indent: 10px;
}
/deep/.el-input__inner {
  height: 26px !important;
  width: 70px;
  border: 1px solid #409eff ;
}

// 弹窗的标题
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
// 弹窗的主体内容
.main-body {
    width: 400px;
    margin: 0 auto;
    text-align: left;
    .label-text {
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      margin-bottom: 10px;
      display: block;
    }
    //扫码充值弹窗
    .Code {
      width: 120px;
      height: 290px;
      margin: 0 auto;
      img {
        width: 120px;
        height: 120px;
        z-index: 999;
      }
      .PaymentMethod {
        display: flex;
        width: 100%;
        height: 30px;
        margin-top: 20px;
        margin-bottom: 10px;
        .PaymentMethod-img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        span {
          line-height: 30px;
          margin-left: 10px;
        }
      }
      span {
        font-size: 12px;
        color: #333333;
        text-align: center;
        font-weight: 400;
      }
    }
    //选择金额
    .amount-Select {
      min-width: 345px;
      max-width: 350px;
      height: 80px;
      margin-top: 10px;
      margin-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      span {
        width: 75px;
        height: 25px;
        line-height: 25px;
        margin-right: 10px;
        background: #ffffff;
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        font-weight: 400;
        cursor: pointer;
        display: inline-block;
      }
      .SelectAmount {
        background: #409eff ;
        color: #ffffff;
      }
    }
    // 选择支付方式
    .Payment-method {
      display: flex;
      height: 30px;
      line-height: 30px;
      margin-top: 15px;
      .way {
        display: flex;
        margin-right: 80px;
      }
      .notSelect {
        width: 18px;
        height: 18px;
        background-image: url("../../../../../assets/imgs/weigouxuan@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 20px;
        cursor: pointer;
      }
      .Select {
        width: 18px;
        height: 18px;
        background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 20px;
        cursor: pointer;
      }
      .icon {
        width: 30px;
        height: 30px;
        margin: auto 0;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      span {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
    }
    .Events {
      margin-top: 20px;
      margin-bottom: 10px;
      color: #f5a854;
      font-size: 12px;
    }
    .agreement-text {
      font-size: 12px;
      color: #333333;
      font-weight: 400;
    }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}

// 输入框
/deep/.el-textarea__inner {
  border: 1px solid #409eff ;
  margin-top: 10px;
}
</style>
